/**
* ComebackRetargetController
* @namespace gplans.layout.controllers
*/
(function () {
  'use strict';ComebackRetargetController.$inject = ["$rootScope", "$state", "Authentication", "$window", "$analytics", "$location"];

  angular.
  module('gplans.layout.controllers').
  controller('ComebackRetargetController', ComebackRetargetController);

  ComebackRetargetController.$inject = ['$rootScope', '$state', 'Authentication', '$window', '$analytics', '$location'];

  /**
                                                                                                                         * @namespace ComebackRetargetController
                                                                                                                         */
  function ComebackRetargetController($rootScope, $state, Authentication, $window, $analytics, $location) {
    oldRetargetPageActivate();

    function oldRetargetPageActivate() {
      var baseHref = jQuery('base').prop('href').replace('dash/', '');
      Authentication.check().then(function (res) {
        location.href = baseHref + 'store/plan/payment_retargeted';
        //$state.go('base.store_payment_after_retargeting');
      }, function (error) {
        // not authenticated
        //$state.go('base.start_quiz_and_run');
        location.href = baseHref + 'survey/start-quiz';
      });
    }

    function activate() {
      Authentication.check().then(function (res) {
        //$state.go('base.store_payment_after_retargeting');
        change_href();
      }, function (error) {
        // not authenticated
        //$state.go('base.start_quiz_and_run');
        change_href();

      });
    }

    function change_href() {
      $http({
        url: gplansConf.API_URL + '/',
        method: "GET",
        params: $location.search() }).
      then(function () {
        $state.go('base.store_payment_before_quiz');
      });
      /*
          var url = $location.url();
          var url_splitted = url.split('?');
          if (url_splitted.length >= 2) {
            var get_params = url_splitted[1];
          }
          else {
            var get_params = '';
          }
          var baseHref = jQuery('base').prop('href');
          location.href = baseHref + 'store/plan/payment_straight_sale?' + get_params;
          */
    }

    var unregister = $rootScope.$watch(function () {
      return $window.Intercom && $window.Intercom.booted;
    }, function (newVal, oldVal) {
      if (angular.isDefined(newVal)) {
        unregister();
        $analytics.eventTrack("Retargeted");
      }
    });
  }
})();